import { communitiesAdminCommunitiesSchema } from "../../../../lib/types/schema/community/admin/communitiesAdminCommunitiesSchema";
import type { RequestProps } from "../../../../request/request";
import { request } from "../../../../request/request";

export const requestCommunitiesAdminCommunitiesProps = {
  schema: communitiesAdminCommunitiesSchema,
  urlBackendPath: "/me/communities/admin",
};

export type RequestCommunitiesAdminCommunitiesProps = RequestProps;

export const requestCommunitiesAdminCommunities = ({ ...props } = {}) =>
  request({
    ...props,
    ...requestCommunitiesAdminCommunitiesProps,
  });
